import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount, currency = 'TND') {
  const value = amount ?? 0;
  return `${Number(value).toFixed(2)} ${currency}`;
}

export function formatDate(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString('de-DE', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  });
}

export function formatTime(timeString) {
  return timeString;
}

export function formatDateTime(isoString) {
  const date = new Date(isoString);
  return date.toLocaleString('de-DE', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function getEloRank(elo) {
  if (elo >= 2000) return { name: 'Grand Master', color: 'text-yellow-500', bg: 'bg-yellow-500/10' };
  if (elo >= 1600) return { name: 'Master', color: 'text-purple-500', bg: 'bg-purple-500/10' };
  if (elo >= 1400) return { name: 'Expert', color: 'text-blue-500', bg: 'bg-blue-500/10' };
  if (elo >= 1200) return { name: 'Advanced', color: 'text-green-500', bg: 'bg-green-500/10' };
  if (elo >= 1000) return { name: 'Intermediate', color: 'text-teal-500', bg: 'bg-teal-500/10' };
  return { name: 'Beginner', color: 'text-gray-500', bg: 'bg-gray-500/10' };
}

export function getMatchStatusBadge(status) {
  switch (status) {
    case 'open':
      return { text: 'Offen', className: 'bg-tunis-teal text-white text-xs font-bold px-2 py-1 rounded-full' };
    case 'full':
      return { text: 'Voll', className: 'bg-amber-500 text-white text-xs font-bold px-2 py-1 rounded-full' };
    case 'in_progress':
      return { text: 'Läuft', className: 'bg-blue-500 text-white text-xs font-bold px-2 py-1 rounded-full' };
    case 'awaiting_result':
      return { text: 'Ergebnis fehlt', className: 'bg-orange-500 text-white text-xs font-bold px-2 py-1 rounded-full' };
    case 'result_submitted':
      return { text: 'Zur Prüfung', className: 'bg-purple-500 text-white text-xs font-bold px-2 py-1 rounded-full' };
    case 'completed':
      return { text: 'Beendet', className: 'bg-gray-500 text-white text-xs font-bold px-2 py-1 rounded-full' };
    case 'cancelled':
      return { text: 'Abgesagt', className: 'bg-red-500 text-white text-xs font-bold px-2 py-1 rounded-full' };
    default:
      return { text: status || 'Unbekannt', className: 'bg-gray-500 text-white text-xs font-bold px-2 py-1 rounded-full' };
  }
}

export function generateInitials(name) {
  return name
    .split(' ')
    .map(word => word[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}
